const states = [
    {
        id: 'new',
        description: "Nova"
    },
    {
        id: 'draft',
        description: "Esborrany"
    },
    {
        id: 'active',
        description: "Publicada"
    },
    {
        id: 'deleted',
        description: "Esborrada"
    }
]

export { states }


// WEBPACK FOOTER //
// ./src/services/state.service.js